import { render, staticRenderFns } from "./ViewCalendar.vue?vue&type=template&id=a4a605ea"
import script from "./ViewCalendar.vue?vue&type=script&lang=js"
export * from "./ViewCalendar.vue?vue&type=script&lang=js"
import style0 from "./ViewCalendar.vue?vue&type=style&index=0&id=a4a605ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports